module.exports = __webpack_public_path__ + "static/media/pitch-mock-4.8ad82dfd.png";